// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonImportError_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M18.75 24C21.6495 24 24 21.6495 24 18.75C24 15.8505 21.6495 13.5 18.75 13.5C15.8505 13.5 13.5 15.8505 13.5 18.75C13.5 21.6495 15.8505 24 18.75 24ZM16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" fill="#ED5353"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.875 15.75L15.75 16.875L17.625 18.75L15.75 20.625L16.875 21.75L18.75 19.875L20.625 21.75L21.75 20.625L19.875 18.75L21.75 16.875L20.625 15.75L18.75 17.625L16.875 15.75Z" class="svg-fg"/>
  <path d="M10.9941 13.0041 11.7464 5.83334 9.34002 7.09676C8.3713 5.34877 6.28185 3.94764 3.97264 3.85494 2.68771 3.80335 1.47365 4.1286.439941 4.73236.603368 4.72662.76948 4.72702.93534 4.73368 3.47113 4.83548 5.92601 6.06907 7.0893 8.27847L4.66422 9.55171 10.9941 13.0041ZM3.99994 11.4647V18.0043H11.5379C11.5128 18.2495 11.5 18.4982 11.5 18.75 11.5 19.1778 11.537 19.5969 11.6081 20.0043H1.99994V10.3739L3.99994 11.4647ZM22.9999 12.8756V5.0043H13.8445L13.6347 7.0043H20.9999V11.8559C21.7233 12.0918 22.3966 12.4384 22.9999 12.8756Z" class="svg-bg"/>
  <path d="M3.11387 5.11127C3.38559 5.19698 3.65159 5.2968 3.9103 5.41052C4.29232 5.57842 4.65813 5.77659 5.00185 6.0043C4.42542 5.6224 3.78701 5.32355 3.11387 5.11127Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonImportError is a generated icon component.
 */
let IconCommonImportError = IconCommonImportError_1 = class IconCommonImportError extends IconBaseElement {
    render() {
        return html `${IconCommonImportError_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonImportError.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonImportError = IconCommonImportError_1 = __decorate([
    customElement('zui-icon-common-import-error')
], IconCommonImportError);
export { IconCommonImportError };
